module.exports = __webpack_public_path__ + "static/media/dieseldyno2.cb255889.webp";